import * as React from 'react';
import { unformatPhoneNumber } from '../../../../utilities/Utils';
import Button from '../../../common/form/Button';
import FormPhoneInput from '../../../common/form/PhoneInput';

interface Props {
    buttonText: string;
    phoneNumberValue: string;
    onChange: (value: string) => void;
    onSubmit: () => Promise<void>;
    helpText?: string;
}

const ProspectPhoneNumberEntry = (props: Props) => {
    return (
        <>
            <FormPhoneInput
                labelProps={{
                    labelText: undefined,
                    removeBoldFont: true
                }}
                inputProps={{
                    id: 'mobile-number',
                    name: 'mobileNumber',
                    required: true,
                    value: props.phoneNumberValue,
                    placeholder: 'Your Mobile Number'
                }}
                helpTextProps={
                    props.helpText
                        ? {
                              helpText: props.helpText,
                              helpTextClass: 'help-text'
                          }
                        : undefined
                }
                onChange={(_, value) => props.onChange(value)}
            />
            <div className="prospect-auth-button-container">
                <Button
                    text={props.buttonText}
                    addlClassName="btn-full-width btn-primary"
                    suppressBottomMargin={true}
                    removeBoldFont={true}
                    onClick={props.onSubmit}
                    disabled={unformatPhoneNumber(props.phoneNumberValue).length < 10}
                />
            </div>
        </>
    );
};

export default ProspectPhoneNumberEntry;



// WEBPACK FOOTER //
// ./src/components/pages/prospect/public/ProspectPhoneNumberEntry.tsx